import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { QuillEditorComponent } from 'ngx-quill';
import Quill from 'quill';
import Delta from 'quill';

@Component({
  selector: 'app-richtext',
  templateUrl: './richtext.component.html',
  styleUrls: ['./richtext.component.css']
})
export class RichtextComponent  implements OnInit{
  @ViewChild('editor') editor: QuillEditorComponent | undefined;
  @Input() content = "";
  @Output() contentChange = new EventEmitter();

  format = 'html';
  form: any;
  quillConfig = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],
        ['code-block'],
        [{ header: 1 }, { header: 2 }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['clean'],
        ['link'],
      ],
      handlers: {
        source: () => {
          this.formatChange();
        },
      },
    },
  };

  constructor(private fb: FormBuilder) { }
  
  ngOnInit() {
    this.form = this.fb.group({
      editor: this.content,
    });
    let icons = Quill.import('ui/icons');
    icons['source'] = '[source]';
  }
  formatChange() {
    this.format = this.format === 'html' ? 'text' : 'html';

    if (this.format === 'text' && this.editor) {
      const htmlText = this.form.get('editor').value;
      this.editor.quillEditor.setText(htmlText);
    } else if (this.format === 'html' && this.editor) {
      const htmlText = this.form.get('editor').value;
      this.editor.quillEditor.setText('');
      this.editor.quillEditor.pasteHTML(0, htmlText);
    }
  }

  onFocus = () => {
    console.log('On Focus');
  };

  onBlur = () => {
    console.log('Blurred');
  };

  save(){
    this.contentChange.emit(this.form.value.editor)
  }
}
